"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    selectVariants: ()=>selectVariants,
    select: ()=>Select_variants_select
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const Select_variants_select = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        root: 'relative flex flex-col gap-1 antialiased',
        label: 'text-primary-13 text-body3 relative hover:cursor-pointer',
        inputWrapper: [
            'bg-primary-1 relative flex items-center justify-items-start gap-3 px-4 py-2',
            'border-primary-6 rounded-xl border',
            'focus-visible:outline-primary-8 focus-visible:shadow-input-focus',
            'hover:border-primary-10 hover:shadow-input-hover hover:cursor-pointer'
        ],
        input: 'text-primary-13 text-body1 w-full truncate',
        helperText: 'text-primary-13 text-body3 ml-4',
        errorText: 'text-error-8 text-body3 ml-4',
        iconLeft: 'text-primary-8',
        iconRight: 'text-primary-10 flex',
        popupPositioner: 'z-[50]',
        popupMenu: 'bg-primary-1 shadow-overlay-md !max-h-[80vh] min-w-[var(--anchor-width)] rounded-xl p-[4px] outline-none',
        popupItem: [
            'flex min-h-[40px] w-full items-center justify-between gap-[12px] rounded-lg px-[12px] py-[8px]',
            'focus-visible:outline-primary-8 [&:hover,&:focus]:bg-primary-2 hover:cursor-pointer hover:outline-none focus-visible:outline focus-visible:outline-2'
        ],
        itemLabel: 'text-body2',
        itemLabelHelper: 'text-body3',
        itemSuffix: 'text-body2 text-primary-10',
        itemIcon: 'text-primary-10 mr-[12px]',
        itemLabelIconSuffixWrapper: 'flex w-full items-center justify-between gap-[8px]',
        itemLabelIconWrapper: 'flex items-center',
        itemLabelWrapper: 'text-primary-13',
        itemSelectedIconWrapper: 'flex h-[20px] w-[20px]',
        itemSelectedIcon: 'text-primary-13',
        errorTooltipTrigger: 'text-error-8'
    },
    variants: {
        isInset: {
            true: {
                label: [
                    'text-primary-10 z-1 absolute left-[17px] mb-0'
                ],
                input: 'translate-y-2'
            }
        },
        size: {
            sm: {
                inputWrapper: 'h-[32px] rounded-xl',
                popupMenu: 'top-[36px]'
            },
            md: {
                inputWrapper: 'h-[48px]',
                popupMenu: 'top-[52px]'
            },
            lg: {
                inputWrapper: 'h-[56px]',
                popupMenu: 'top-[60px]'
            }
        },
        isAutoWidth: {
            true: {
                inputWrapper: 'w-auto',
                input: 'whitespace-nowrap'
            }
        },
        hasIconLeft: {
            true: {
                input: 'ml-0'
            }
        },
        hasValue: {
            true: {
                input: 'text-primary-13'
            },
            false: {
                input: 'text-primary-10'
            }
        },
        hasPlaceholder: {
            true: {}
        },
        isError: {
            true: {
                inputWrapper: 'border-error-4 hover:border-error-7 focus-visible:outline-error-8'
            }
        },
        isDisabled: {
            true: {
                iconLeft: 'text-primary-6',
                iconRight: 'text-primary-10',
                inputWrapper: 'bg-primary-2 border-primary-5 cursor-not-allowed',
                input: 'text-primary-6'
            }
        },
        itemSelected: {
            true: {
                popupItem: 'bg-primary-4 [&:hover,&:focus]:bg-primary-4'
            }
        },
        itemDisabled: {
            true: {
                itemLabelWrapper: 'text-primary-6',
                itemSuffix: 'text-primary-6',
                itemIcon: 'text-primary-6',
                popupItem: 'cursor-not-allowed'
            }
        },
        itemSuffixInline: {
            true: {
                itemLabelIconSuffixWrapper: 'justify-start gap-0'
            }
        },
        isLabelHidden: {
            true: {
                label: 'hidden'
            }
        },
        menuOpen: {
            true: {
                inputWrapper: 'border-primary-8 shadow-input-focus'
            }
        }
    },
    compoundVariants: [
        {
            isInset: true,
            isDisabled: true,
            class: {
                label: 'text-primary-6'
            }
        },
        {
            isInset: true,
            size: 'sm',
            class: {
                label: 'translate-y-0'
            }
        },
        {
            isInset: true,
            size: 'md',
            class: {
                label: 'translate-y-1.5'
            }
        },
        {
            isInset: true,
            size: 'lg',
            class: {
                label: 'translate-y-2'
            }
        },
        {
            hasIconLeft: true,
            isInset: true,
            class: {
                label: 'left-13 ml-[1px]'
            }
        },
        {
            hasValue: false,
            hasPlaceholder: false,
            isInset: true,
            class: {
                input: 'translate-none',
                label: 'invisible'
            }
        },
        {
            menuOpen: true,
            isError: true,
            class: {
                inputWrapper: 'border-error-8 shadow-input-error'
            }
        }
    ],
    defaultVariants: {
        emphasis: 'regular',
        isInset: false,
        size: 'md'
    }
});
const selectVariants = Select_variants_select;
exports.select = __webpack_exports__.select;
exports.selectVariants = __webpack_exports__.selectVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "select",
    "selectVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
